(function () {
  const facets = document.querySelector('.facets-wrapper');
  const grid = document.querySelector('.collection-product-grid');
  if (!facets || !grid) return;

  const OFFSET = 400;

  const getTopOffset = () => {
    const t = parseFloat(getComputedStyle(facets).top);
    return isNaN(t) ? 0 : t;
  };

  let ticking = false;

  const update = () => {
    ticking = false;

    if (getComputedStyle(facets).position !== 'sticky') {
      facets.classList.remove('is-grid-ending');
      return;
    }

    const gridBottom = grid.getBoundingClientRect().bottom;
    const stickyBottom = getTopOffset() + facets.offsetHeight;

    facets.classList.toggle('is-grid-ending', gridBottom - OFFSET <= stickyBottom);
  };

  const onScroll = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  new ResizeObserver(onScroll).observe(grid);

  document.addEventListener('shopify:section:load', onScroll);

  update();
})();

// header-drawer.js
document.addEventListener('DOMContentLoaded', () => {
  const navContainer = document.querySelector('.menu-drawer__navigation-container');
  const mainMenuUl = document.querySelector('.menu-drawer__navigation > .menu-drawer__menu');
  const menuDetails = navContainer ? navContainer.querySelectorAll('details') : [];
  const topLevelDetails = mainMenuUl ? mainMenuUl.querySelectorAll(':scope > li > details') : [];
  const mainDrawer = document.querySelector('details.menu-drawer-container');
  const HEIGHT_TRANSITION_MS = 200;

  if (!navContainer || !mainMenuUl) return;

  let collapseTimer = null;

  function getInnerSubmenus() {
    return navContainer.querySelectorAll('.menu-drawer__inner-submenu');
  }

  function applyOverlayLayout() {
    navContainer.style.overflow = 'hidden';
    navContainer.style.position = 'relative';
    navContainer.style.transition = 'height 0.2s ease-in-out';

    menuDetails.forEach(details => {
      const submenu = details.querySelector(':scope > .menu-drawer__submenu');
      if (submenu) {
        submenu.style.position = 'absolute';
        submenu.style.top = '0';
        submenu.style.left = '0';
        submenu.style.bottom = 'auto';
        submenu.style.width = '100%';
        submenu.style.height = 'auto';
      }
    });

    getInnerSubmenus().forEach(inner => {
      inner.style.minHeight = '0';
    });
  }

  function measureNaturalHeight(element) {
    const previousMinHeight = element.style.minHeight;
    const previousHeight = element.style.height;
    element.style.minHeight = '0';
    element.style.height = 'auto';
    const height = element.scrollHeight;
    element.style.minHeight = previousMinHeight;
    element.style.height = previousHeight;
    return height;
  }

  function getCollapsedHeight() {
    return mainMenuUl.offsetHeight;
  }

  function isAnyTopLevelOpen() {
    return Array.from(topLevelDetails).some(details => details.open);
  }

  function getTargetHeight() {
    let targetHeight = getCollapsedHeight();

    topLevelDetails.forEach(details => {
      if (!details.open) return;

      const submenu = details.querySelector(':scope > .menu-drawer__submenu');
      if (!submenu) return;

      const innerContent = submenu.querySelector('.menu-drawer__inner-submenu') || submenu;
      const contentHeight = measureNaturalHeight(innerContent);
      if (contentHeight > targetHeight) {
        targetHeight = contentHeight;
      }
    });

    return targetHeight;
  }

  function syncNavHeight() {
    if (collapseTimer) {
      clearTimeout(collapseTimer);
      collapseTimer = null;
    }

    const anyOpen = isAnyTopLevelOpen();
    const toHeight = anyOpen ? getTargetHeight() : getCollapsedHeight();
    const fromHeight = navContainer.offsetHeight;

    if (fromHeight === toHeight) {
      navContainer.style.height = anyOpen ? toHeight + 'px' : '';
      return;
    }

    navContainer.style.height = fromHeight + 'px';
    void navContainer.offsetHeight;
    navContainer.style.height = toHeight + 'px';

    if (!anyOpen) {
      collapseTimer = setTimeout(() => {
        if (!isAnyTopLevelOpen()) {
          navContainer.style.height = '';
        }
        collapseTimer = null;
      }, HEIGHT_TRANSITION_MS);
    }
  }

  function scheduleSyncNavHeight() {
    requestAnimationFrame(syncNavHeight);
  }

  applyOverlayLayout();
  window.addEventListener('resize', () => {
    applyOverlayLayout();
    scheduleSyncNavHeight();
  });

  menuDetails.forEach(details => {
    details.addEventListener('toggle', scheduleSyncNavHeight);
  });

  if (mainDrawer) {
    mainDrawer.addEventListener('toggle', () => {
      if (mainDrawer.open) return;
      if (collapseTimer) {
        clearTimeout(collapseTimer);
        collapseTimer = null;
      }
      navContainer.style.height = '';
    });
  }
});
// Swallow the mobile ghost click that lands on the same summary after open
// (hamburger and close share one button; a second click would close the menu).
document.addEventListener('DOMContentLoaded', () => {
  const drawers = document.querySelectorAll('details.menu-drawer-container');

  drawers.forEach((drawer) => {
    const summary = drawer.querySelector(':scope > summary');
    if (!summary) return;

    let ignoreClicksUntil = 0;

    summary.addEventListener(
      'click',
      (e) => {
        if (performance.now() < ignoreClicksUntil) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      },
      true
    );

    drawer.addEventListener('toggle', () => {
      if (drawer.open) {
        ignoreClicksUntil = performance.now() + 400;
      }
    });
  });
});

if (!customElements.get('sticky-cart-checkout')) {
  customElements.define(
    'sticky-cart-checkout',
    class StickyCartCheckout extends HTMLElement {
      connectedCallback() {
        const existing = document.querySelector('body > sticky-cart-checkout');
        if (existing && existing !== this) {
          existing.rebind();
          this.remove();
          return;
        }

        // Move to body so position:fixed is not trapped by section stacking.
        // appendChild disconnects then reconnects — bind observers only after the move.
        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
          return;
        }

        this.mediaQuery = window.matchMedia('(max-width: 989px)');
        this.onMediaChange = this.onMediaChange.bind(this);
        this.rebind = this.rebind.bind(this);
        this.inert = true;

        this.mediaQuery.addEventListener('change', this.onMediaChange);
        this.observeSummary();
        this.subscribeCartUpdates();
        this.onMediaChange();
      }

      disconnectedCallback() {
        this.mediaQuery?.removeEventListener('change', this.onMediaChange);
        this.observer?.disconnect();
        this.summaryObserver?.disconnect();
        this.cartUnsubscriber?.();
        this.observedButton = null;
        document.body.classList.remove('sticky-cart-checkout-visible');
      }

      subscribeCartUpdates() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.cartUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          requestAnimationFrame(this.rebind);
        });
      }

      observeSummary() {
        this.summaryObserver?.disconnect();

        const summary = document.getElementById('main-cart-summary');
        if (!summary || typeof MutationObserver === 'undefined') return;

        this.summaryObserver = new MutationObserver(() => {
          requestAnimationFrame(this.rebind);
        });
        this.summaryObserver.observe(summary, { childList: true, subtree: true });
      }

      onMediaChange() {
        if (!this.mediaQuery.matches) {
          this.hide();
          this.observer?.disconnect();
          this.observedButton = null;
          return;
        }

        this.bindObserver();
      }

      rebind() {
        this.observeSummary();
        this.bindObserver();
      }

      getOriginalButton() {
        return document.querySelector('[data-cart-page-checkout]') || document.getElementById('checkout');
      }

      bindObserver() {
        if (!this.mediaQuery?.matches) {
          this.hide();
          return;
        }

        const original = this.getOriginalButton();
        const cartPage = document.querySelector('cart-items.cart-page');
        const cartEmpty = !original || cartPage?.classList.contains('is-empty');

        if (cartEmpty) {
          this.observer?.disconnect();
          this.observedButton = null;
          this.hide();
          return;
        }

        if (this.observedButton === original && this.observer) return;

        this.observer?.disconnect();
        this.observedButton = original;

        if (typeof IntersectionObserver === 'undefined') {
          this.show();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            if (!entry || !this.mediaQuery.matches) return;

            if (entry.isIntersecting) {
              this.hide();
            } else {
              this.show();
            }
          },
          { root: null, threshold: 0, rootMargin: '0px' }
        );

        this.observer.observe(original);
      }

      isOriginalInView(button) {
        if (!button) return false;
        const rect = button.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
      }

      show() {
        if (this.classList.contains('is-visible')) return;
        if (!this.mediaQuery.matches) return;

        const original = this.getOriginalButton();
        if (!original || this.isOriginalInView(original)) return;

        this._shouldShow = true;
        this.inert = false;
        this.setAttribute('aria-hidden', 'false');
        document.body.classList.add('sticky-cart-checkout-visible');

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (!this._shouldShow || !this.mediaQuery.matches || this.isOriginalInView(this.getOriginalButton())) {
              return;
            }
            this.classList.add('is-visible');
          });
        });
      }

      hide() {
        this._shouldShow = false;
        this.classList.remove('is-visible');
        this.inert = true;
        this.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('sticky-cart-checkout-visible');
      }
    }
  );
}

(() => {
  const mobileQuery = window.matchMedia('(max-width: 1024px)');
  let frameId = 0;

  function syncMobileMenuPosition() {
    frameId = 0;

    if (!mobileQuery.matches) return;

    const header = document.querySelector('.section-header .header');
    const menuDrawer = document.querySelector('header-drawer #menu-drawer');

    if (!header || !menuDrawer) return;

    // 1px overlap prevents a sub-pixel line/gap during scroll.
    const headerBottom = Math.max(
      0,
      header.getBoundingClientRect().bottom - 1
    );

    menuDrawer.style.setProperty(
      '--mobile-menu-top',
      `${headerBottom}px`
    );
  }

  function scheduleSync() {
    if (!frameId) {
      frameId = requestAnimationFrame(syncMobileMenuPosition);
    }
  }

  syncMobileMenuPosition();

  window.addEventListener('scroll', scheduleSync, { passive: true });
  window.addEventListener('resize', scheduleSync);
  mobileQuery.addEventListener('change', syncMobileMenuPosition);

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (event.target.closest('header-drawer summary')) {
        syncMobileMenuPosition();
        requestAnimationFrame(syncMobileMenuPosition);
      }
    },
    true
  );

  document.addEventListener(
    'toggle',
    (event) => {
      if (event.target.matches('header-drawer details')) {
        syncMobileMenuPosition();
        requestAnimationFrame(syncMobileMenuPosition);
      }
    },
    true
  );
})();

/* --------------------------------------------------------------------------
   Header scroll class (works even when sticky header is "None")
   Dawn sticky-header is disabled. This only toggles scrolled-past-header
   on .header-wrapper (and .header) so CSS can apply the black bar.
  -------------------------------------------------------------------------- */
(function () {
  'use strict';

  var SCROLL_CLASS = 'scrolled-past-header';
  var THRESHOLD = 8;

  function syncHeaderScrollClass() {
    if (document.documentElement.classList.contains('has-zoom-intro-active')) return;

    var scrolled = (window.pageYOffset || document.documentElement.scrollTop || 0) > THRESHOLD;
    var wrapper = document.querySelector('.header-wrapper');
    var headerBar = document.querySelector('.header-wrapper .header') || document.querySelector('.header');
    var section = document.querySelector('.section-header');

    if (wrapper) wrapper.classList.toggle(SCROLL_CLASS, scrolled);
    if (headerBar) headerBar.classList.toggle(SCROLL_CLASS, scrolled);
    if (section) section.classList.toggle(SCROLL_CLASS, scrolled);
    document.documentElement.classList.toggle('header-is-scrolled', scrolled);
  }

  syncHeaderScrollClass();
  window.addEventListener('scroll', syncHeaderScrollClass, { passive: true });
  window.addEventListener('load', syncHeaderScrollClass);
  document.addEventListener('shopify:section:load', syncHeaderScrollClass);
})();

/* --------------------------------------------------------------------------
   Zoom intro skip (logo / home click)
   When the user clicks the header logo (or a home link in the header) we
   store a one-time flag. On the next homepage load we skip the cinematic
   zoom intro and reset the hero slider to its normal height so layout
   does not stretch to 400vh.
  -------------------------------------------------------------------------- */
(function () {
  'use strict';

  window.applyZoomIntroSkip = function (root) {
    document.documentElement.classList.remove('has-zoom-intro-active');
    document.documentElement.classList.remove('zoom-header-revealed');
    document.documentElement.classList.add('zoom-intro-skip-active');

    var nodes = root
      ? [root]
      : document.querySelectorAll('[data-hero-slider-section]');

    Array.prototype.forEach.call(nodes, function (el) {
      if (!el || !el.classList) return;
      el.classList.remove('hero-slider--has-zoom-intro');
      var sequence = el.querySelector('[data-zoom-sequence]');
      if (sequence) sequence.style.height = '';
      el.querySelectorAll('[data-hero-reveal]').forEach(function (node) {
        node.classList.add('is-revealed');
      });
      el.querySelectorAll('[data-zoom-media], .hero-slider__media').forEach(function (node) {
        node.style.transform = '';
      });
      if (typeof window.syncHeroSliderAutoplay === 'function') {
        window.syncHeroSliderAutoplay(el, true);
      }
    });

    ['.section-usp-marquee', '.section-header'].forEach(function (selector) {
      var headerEl = document.querySelector(selector);
      if (!headerEl) return;
      headerEl.style.removeProperty('opacity');
      headerEl.style.removeProperty('transform');
    });
  };

  try {
    if (
      sessionStorage.getItem('ppSkipZoomIntro') === '1' ||
      document.documentElement.classList.contains('zoom-intro-skip-active')
    ) {
      sessionStorage.removeItem('ppSkipZoomIntro');
      window.applyZoomIntroSkip();
    }
  } catch (e) { }

  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!link) return;
    var isLogo = link.classList.contains('header__heading-link');
    var href = link.getAttribute('href') || '';
    var homePath = (window.routes && window.routes.root_url) || '/';
    var isHomeLink =
      href === '/' ||
      href === homePath ||
      href === window.location.origin + homePath;
    if (!isLogo && !(isHomeLink && link.closest('.section-header, sticky-header'))) return;
    try {
      sessionStorage.setItem('ppSkipZoomIntro', '1');
    } catch (err) { }
  }, true);
})();

/* --------------------------------------------------------------------------
   Sync zoom-intro class on <html>
  -------------------------------------------------------------------------- */
(function () {
  'use strict';

  function syncZoomIntroState() {
    if (document.documentElement.classList.contains('zoom-intro-skip-active')) {
      if (typeof window.applyZoomIntroSkip === 'function') window.applyZoomIntroSkip();
      return;
    }
    var active = !!document.querySelector('.hero-slider--has-zoom-intro');
    document.documentElement.classList.toggle('has-zoom-intro-active', active);
  }

  document.addEventListener('DOMContentLoaded', syncZoomIntroState);
  window.addEventListener('load', syncZoomIntroState);
  document.addEventListener('shopify:section:load', syncZoomIntroState);
  document.addEventListener('shopify:section:unload', syncZoomIntroState);
})();

/* --------------------------------------------------------------------------
   Announcement bar + header height CSS variables
  -------------------------------------------------------------------------- */
(function () {
  'use strict';

  function syncMarqueeHeight() {
    var marquee = document.querySelector('.section-usp-marquee');
    var header = document.querySelector('.section-header');
    var headerInner = header
      ? header.querySelector('.header-wrapper') || header.querySelector('.header') || header
      : null;
    document.documentElement.style.setProperty(
      '--marquee-height',
      (marquee ? marquee.offsetHeight : 0) + 'px'
    );
    document.documentElement.style.setProperty(
      '--header-height',
      (headerInner ? headerInner.offsetHeight : 0) + 'px'
    );
    document.documentElement.classList.add('marquee-height-ready');
  }

  syncMarqueeHeight();
  document.addEventListener('DOMContentLoaded', syncMarqueeHeight);
  window.addEventListener('load', syncMarqueeHeight);
  window.addEventListener('resize', syncMarqueeHeight);
  document.addEventListener('shopify:section:load', syncMarqueeHeight);
})();

/* --------------------------------------------------------------------------
   Hero slider (Swiper)
  -------------------------------------------------------------------------- */
(function () {
  function initHeroSlider(root) {
    if (!root || typeof Swiper === 'undefined') return;

    var el = root.querySelector('.hero-slider-swiper');
    if (!el) return;

    if (el.swiper) {
      el.swiper.destroy(true, true);
    }

    var slideCount = el.querySelectorAll('.swiper-slide').length;
    var multi = slideCount > 1;
    var effect = root.getAttribute('data-effect') || 'slide';
    var autoplayEnabled = root.getAttribute('data-autoplay') === 'true';
    var autoplayDelay = parseInt(root.getAttribute('data-autoplay-delay'), 10) || 5000;
    var waitForZoomIntro =
      root.classList.contains('hero-slider--has-zoom-intro') &&
      !document.documentElement.classList.contains('zoom-intro-skip-active');

    var swiper = new Swiper(el, {
      loop: multi && autoplayEnabled,
      slidesPerView: 1,
      speed: 800,
      effect: effect,
      autoplay: multi && autoplayEnabled
        ? {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        }
        : false,
      navigation: multi
        ? {
          nextEl: root.querySelector('.hero-slider__next'),
          prevEl: root.querySelector('.hero-slider__prev')
        }
        : undefined,
      pagination: multi
        ? {
          el: root.querySelector('.hero-slider__pagination'),
          clickable: true
        }
        : undefined,
      keyboard: {
        enabled: multi
      },
      grabCursor: multi,
      watchOverflow: true,
      fadeEffect: {
        crossFade: true
      }
    });

    if (waitForZoomIntro && swiper.autoplay) {
      swiper.autoplay.stop();
    }
  }

  window.syncHeroSliderAutoplay = function (root, shouldRun) {
    var nodes = root ? [root] : document.querySelectorAll('.hero-slider');
    Array.prototype.forEach.call(nodes, function (node) {
      if (!node || !node.querySelector) return;
      var slider = node.querySelector('.hero-slider-swiper');
      var instance = slider && slider.swiper;
      if (!instance || !instance.autoplay) return;
      if (shouldRun) instance.autoplay.start();
      else instance.autoplay.stop();
    });
  };

  function initAll() {
    document.querySelectorAll('.hero-slider').forEach(initHeroSlider);
  }

  function whenSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        callback();
      } else if (tries > 40) {
        clearInterval(timer);
      }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      whenSwiperReady(initAll);
    });
  } else {
    whenSwiperReady(initAll);
  }

  if (!window.__heroSliderEventsBound) {
    window.__heroSliderEventsBound = true;

    document.addEventListener('shopify:section:load', function (e) {
      var section =
        e.target.querySelector('.hero-slider') ||
        (e.target.classList && e.target.classList.contains('hero-slider') ? e.target : null);
      if (section) whenSwiperReady(function () { initHeroSlider(section); });
    });

    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.closest('.swiper-slide');
      var root = e.target.closest('.hero-slider');
      if (!slide || !root) return;
      var el = root.querySelector('.hero-slider-swiper');
      if (!el || !el.swiper) return;
      var index = Array.prototype.indexOf.call(
        el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)'),
        slide
      );
      if (index < 0) return;
      if (typeof el.swiper.slideToLoop === 'function' && el.swiper.params.loop) {
        el.swiper.slideToLoop(index);
      } else {
        el.swiper.slideTo(index);
      }
    });
  }
})();

/* --------------------------------------------------------------------------
   Mobile --vh fallback
  -------------------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.__heroSliderVhBound) return;
  window.__heroSliderVhBound = true;

  function getViewportHeight() {
    return window.innerHeight;
  }

  var rafId = null;
  var lastWinWidth = window.innerWidth;

  function setVhVar(force) {
    if (!force && Math.abs(window.innerWidth - lastWinWidth) < 5) return;
    lastWinWidth = window.innerWidth;
    if (rafId) window.cancelAnimationFrame(rafId);
    rafId = window.requestAnimationFrame(function () {
      var vh = getViewportHeight() * 0.01;
      document.documentElement.style.setProperty('--vh', vh + 'px');
    });
  }

  setVhVar(true);
  window.addEventListener('resize', function () { setVhVar(false); });
  window.addEventListener('orientationchange', function () { setVhVar(true); });
  window.addEventListener('load', function () { setVhVar(true); });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', function () { setVhVar(false); });
  }
})();

/* --------------------------------------------------------------------------
   Reset header after zoom intro is gone
  -------------------------------------------------------------------------- */
(function () {
  'use strict';

  function resetHeaderIfNoZoomIntro() {
    var skipActive = document.documentElement.classList.contains('zoom-intro-skip-active');
    var stillHasZoomIntro = document.querySelector('[data-hero-slider-section].hero-slider--has-zoom-intro');
    if (stillHasZoomIntro && !skipActive) return;

    document.documentElement.classList.remove('zoom-header-revealed');

    ['.section-usp-marquee', '.section-header'].forEach(function (selector) {
      var el = document.querySelector(selector);
      if (!el) return;
      ['opacity', 'transform'].forEach(function (prop) {
        el.style.removeProperty(prop);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', resetHeaderIfNoZoomIntro);
  document.addEventListener('shopify:section:load', resetHeaderIfNoZoomIntro);
  document.addEventListener('shopify:section:unload', resetHeaderIfNoZoomIntro);
})();

/* --------------------------------------------------------------------------
   Cinematic zoom intro (scroll animation)
  -------------------------------------------------------------------------- */
(function () {
  'use strict';

  function initZoomIntro(root) {
    if (!root || !root.classList.contains('hero-slider--has-zoom-intro')) {
      if (document.documentElement.classList.contains('zoom-intro-skip-active') && typeof window.applyZoomIntroSkip === 'function') {
        window.applyZoomIntroSkip(root);
      }
      return;
    }

    if (document.documentElement.classList.contains('zoom-intro-skip-active')) {
      if (typeof window.applyZoomIntroSkip === 'function') window.applyZoomIntroSkip(root);
      return;
    }

    var sequence = root.querySelector('[data-zoom-sequence]');
    var zoomLayer = root.querySelector('[data-zoom-layer]');
    var zoomImg = zoomLayer ? zoomLayer.querySelector('img') : null;
    var voidLayer = root.querySelector('[data-zoom-void]');
    var revealLayer = root.querySelector('[data-zoom-reveal-layer]');
    var zoomMediaEl = revealLayer ? revealLayer.querySelector('[data-zoom-media]') : null;
    var scrollCue = root.querySelector('[data-zoom-scroll-cue]');
    var skipBtn = root.querySelector('[data-zoom-skip]');
    var contentEls = root.querySelectorAll('[data-hero-reveal]');
    var announcementBar = document.querySelector('.section-usp-marquee');
    var headerSection = document.querySelector('.section-header');

    function setHeaderRevealed(revealed) {
      document.documentElement.classList.toggle('zoom-header-revealed', !!revealed);
      if (headerSection) {
        headerSection.style.removeProperty('transform');
        headerSection.style.removeProperty('opacity');
      }
      if (announcementBar) {
        announcementBar.style.removeProperty('transform');
        announcementBar.style.removeProperty('opacity');
      }
    }

    if (!sequence || !zoomImg || !revealLayer) return;
    if (root.dataset.zoomIntroBound) return;
    root.dataset.zoomIntroBound = 'true';

    var zoomScale = parseFloat(getComputedStyle(root).getPropertyValue('--zoom-scale')) || 3.1;
    var configuredScrollVh = parseFloat(getComputedStyle(root).getPropertyValue('--zoom-scroll-vh')) || 400;

    function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }
    function lerp(a, b, t) { return a + (b - a) * t; }
    function range(p, start, end) {
      if (end === start) return p >= end ? 1 : 0;
      return clamp((p - start) / (end - start), 0, 1);
    }
    function easeInOutCubic(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function easeOutQuint(t) { return 1 - Math.pow(1 - t, 5); }

    var seqTop = 0;
    var scrollableDist = 1;
    var naturalScrollable = 1;
    var viewportH = 0;
    var marqueeHeightPx = 0;
    var headerIsSticky = false;
    var heroAutoplayRunning = false;
    var contentRevealTriggered = false;

    var CONTENT_REVEAL_P = 0.55;
    var CONTENT_HIDE_P = 0.45;
    var LAYER_REVEAL_P = 0.50;
    var LAYER_HIDE_P = 0.30;
    var layerRevealTriggered = false;
    var HEADER_REVEAL_P = 0.55;
    var HEADER_HIDE_P = 0.35;
    var headerRevealTriggered = false;
    var headerRevealAtMs = 0;
    var HEADER_REVEAL_DURATION_MS = 600;
    var HEADER_STICKY_EXIT_THRESHOLD = 0.1;
    var REVEAL_COMPLETE_P = 0.65;

    function setHeaderSticky(shouldStick) {
      if (!headerSection) return;
      headerSection.classList.toggle('header-sticky', shouldStick);
      headerSection.classList.toggle('scrolled-past-header', shouldStick);
      document.documentElement.classList.toggle('header-is-scrolled', shouldStick);
      var wrapper = headerSection.querySelector('.header-wrapper');
      var headerBar = headerSection.querySelector('.header');
      if (wrapper) wrapper.classList.toggle('scrolled-past-header', shouldStick);
      if (headerBar) headerBar.classList.toggle('scrolled-past-header', shouldStick);
      headerIsSticky = shouldStick;
    }

    var lastWinWidth = window.innerWidth;

    function getViewportHeight() {
      if (zoomLayer && zoomLayer.parentElement && zoomLayer.parentElement.clientHeight) {
        return zoomLayer.parentElement.clientHeight;
      }
      return window.innerHeight;
    }

    function measure(e) {
      if (e && (e.type === 'resize' || e.type === 'visualViewportResize')) {
        var winW = window.innerWidth;
        if (Math.abs(winW - lastWinWidth) < 5) return;
        lastWinWidth = winW;
      }

      seqTop = sequence.getBoundingClientRect().top + window.scrollY;
      viewportH = getViewportHeight();

      var naturalHeight = (configuredScrollVh / 100) * viewportH;
      naturalScrollable = Math.max(naturalHeight - viewportH, 1);
      scrollableDist = Math.max(naturalScrollable * REVEAL_COMPLETE_P, 1);

      sequence.style.height = viewportH + scrollableDist + 'px';
    }

    var targetP = 0;
    var currentP = 0;
    var lastTargetP = 0;
    var SMOOTHING_FACTOR = 0.09;
    var rafId = null;

    function render(p) {
      var zoomT = easeInOutCubic(range(p, 0.0, 0.425));
      var scale = lerp(1, zoomScale, zoomT);
      var translateY = lerp(0, -6, zoomT);
      zoomImg.style.transform = 'scale(' + scale.toFixed(4) + ') translateY(' + translateY.toFixed(2) + '%)';

      var fadeT = easeInOutCubic(range(p, 0.30, 0.575));
      if (voidLayer) voidLayer.style.opacity = fadeT;

      zoomLayer.style.opacity = 1 - clamp(range(p, 0.50, 0.625), 0, 1);

      if (voidLayer) voidLayer.style.opacity = clamp(fadeT - range(p, 0.55, REVEAL_COMPLETE_P), 0, 1);

      var pullT = easeOutQuint(range(p, 0.525, REVEAL_COMPLETE_P));
      var revealScale = lerp(1.13, 1.0, pullT);

      var activeMediaEl = revealLayer.querySelector('.swiper-slide-active .hero-slider__media') || zoomMediaEl;
      if (activeMediaEl) {
        activeMediaEl.style.transform = 'scale(' + revealScale.toFixed(4) + ')';
      }

      if (contentEls.length && !contentRevealTriggered && p >= CONTENT_REVEAL_P) {
        contentRevealTriggered = true;
        contentEls.forEach(function (el, i) {
          el.style.transitionDelay = i * 0.08 + 's';
          el.classList.add('is-revealed');
        });
      }

      if (scrollCue) {
        var cueOpacity = clamp(1 - range(p, 0.025, 0.15), 0, 1);
        scrollCue.style.opacity = cueOpacity;
        scrollCue.style.pointerEvents = cueOpacity < 0.05 ? 'none' : 'auto';
      }
      if (skipBtn) {
        var skipOpacity = clamp(1 - fadeT, 0, 1);
        skipBtn.style.opacity = skipOpacity;
        skipBtn.style.pointerEvents = skipOpacity < 0.05 ? 'none' : 'auto';
      }
    }

    function tick() {
      var scrollY = window.scrollY || window.pageYOffset;
      var pinnedSectionEndScrollY = seqTop + scrollableDist;

      var pinnedProgress = clamp((scrollY - seqTop) / scrollableDist, 0, 1);
      targetP = pinnedProgress * REVEAL_COMPLETE_P;
      lastTargetP = targetP;

      currentP = lerp(currentP, targetP, SMOOTHING_FACTOR);
      if (Math.abs(targetP - currentP) < 0.0008) currentP = targetP;

      if (revealLayer && !layerRevealTriggered && currentP >= LAYER_REVEAL_P) {
        layerRevealTriggered = true;
        revealLayer.classList.add('zoom-layer-visible');
      }

      if (!headerRevealTriggered && currentP >= HEADER_REVEAL_P) {
        headerRevealTriggered = true;
        headerRevealAtMs = performance.now();
        setHeaderRevealed(true);
      }

      render(currentP);
      var exitProgress = clamp((scrollY - pinnedSectionEndScrollY) / viewportH, 0, 1);
      var headerSlideDone =
        headerRevealTriggered && performance.now() - headerRevealAtMs >= HEADER_REVEAL_DURATION_MS;
      var introComplete = currentP >= REVEAL_COMPLETE_P;
      var shouldStick =
        headerSlideDone && introComplete && exitProgress >= HEADER_STICKY_EXIT_THRESHOLD;

      if (shouldStick !== headerIsSticky) {
        setHeaderSticky(shouldStick);
      }

      if (introComplete !== heroAutoplayRunning) {
        heroAutoplayRunning = introComplete;
        if (typeof window.syncHeroSliderAutoplay === 'function') {
          window.syncHeroSliderAutoplay(root, introComplete);
        }
      }

      if (currentP <= CONTENT_HIDE_P && contentRevealTriggered) {
        contentRevealTriggered = false;
        contentEls.forEach(function (el) {
          el.classList.remove('is-revealed');
        });
      }

      if (revealLayer && layerRevealTriggered && currentP <= LAYER_HIDE_P) {
        layerRevealTriggered = false;
        revealLayer.classList.remove('zoom-layer-visible');
      }

      if (headerRevealTriggered && currentP <= HEADER_HIDE_P) {
        headerRevealTriggered = false;
        headerRevealAtMs = 0;
        setHeaderRevealed(false);
        if (headerIsSticky) setHeaderSticky(false);
      }

      rafId = window.requestAnimationFrame(tick);
    }

    function skipToReveal() {
      measure();
      var target = seqTop + scrollableDist;
      window.scrollTo({ top: target, behavior: 'smooth' });
    }

    if (skipBtn) skipBtn.addEventListener('click', skipToReveal);

    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', measure);
    }
    measure();
    window.setTimeout(measure, 300);

    if (rafId === null) rafId = window.requestAnimationFrame(tick);
  }

  function initAllZoomIntros() {
    document.querySelectorAll('[data-hero-slider-section]').forEach(initZoomIntro);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllZoomIntros);
  } else {
    initAllZoomIntros();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var root = evt.target.querySelector('[data-hero-slider-section]');
    if (root) initZoomIntro(root);
  });
})();